import { usePathname } from "next/navigation";
import useRegionAndLocale from "./useRegionAndLocale";

const useStorePathname = () => {
	const { region, locale } = useRegionAndLocale();
	const pathname = usePathname();

	return pathname.replace(`/${region}`, "").replace(`/${locale}`, "");
};

export default useStorePathname;
